import { useState } from "react";
import * as S from "./AlarmOptionPageContent.styles";

type AlarmOptionPageCotentType = {
  onToggleHandler: () => void;
  isAlramOn: boolean;
};

const AlarmOptionPageContent = ({
  onToggleHandler,
  isAlramOn,
}: AlarmOptionPageCotentType) => {
  return (
    <S.AlarmContentBox>
      <S.LabelTit>알림 수신</S.LabelTit>
      <S.PageContainer>
        <S.ToggleContainer onClick={onToggleHandler}>
          <div className="toggleBox">
            <div
              className={`toggle-container ${
                isAlramOn ? "toggle--checked" : ""
              }`}
            >
              <span className={`${!isAlramOn ? "toggleLeft" : ""}`}>
                {isAlramOn ? "" : "꺼짐"}
              </span>
              <span
                className={`${isAlramOn ? "toggLeft" : ""}`}
                style={{ marginTop: "2px" }}
              >
                {isAlramOn ? "켜짐" : ""}
              </span>
            </div>
            <div
              className={`toggle-circle ${isAlramOn ? "toggle--checked" : ""}`}
            />
          </div>
        </S.ToggleContainer>
      </S.PageContainer>
    </S.AlarmContentBox>
  );
};

export default AlarmOptionPageContent;
